import Dexie, { Table } from 'dexie';
import { reportCustomError } from '@utils/owlReporter';
import { IAllPoiList } from '../../projects/Shell/api/define';

class WmIndexDB extends Dexie {
    poiList!: Table<IAllPoiList>;

    constructor() {
        super('WmIndexDB');
        try {
            this.version(1).stores({
                poiList: `++, id, poiName`,
            });
        } catch (e) {
            reportCustomError({
                name: 'db初始化异常',
                message: `db获取poiList异常-${e}`,
            });
        }
    }
}

// eslint-disable-next-line import/prefer-default-export
export const db = new WmIndexDB();
